import { i18n } from "@/main.js";

// All update frequencies we could have in the displayed products.
export const UpdateFrequency = Object.freeze({
  daily: {
    id: "daily",
    getLastChangeName: () => i18n.t("pages.products.overview.lastDayChange"),
  },
  weekly: {
    id: "weekly",
    getLastChangeName: () => i18n.t("pages.products.overview.lastWeekChange"),
  },
  weeklyAndEndOfMonth: {
    id: "weeklyAndEndOfMonth",
    getLastChangeName: () => i18n.t("pages.products.overview.lastChange"),
  },
  monthly: {
    id: "monthly",
    getLastChangeName: () => i18n.t("pages.products.overview.lastMonthChange"),
  },
  quarterly: {
    id: "quarterly",
    getLastChangeName: () => i18n.t("pages.products.overview.lastQuarterChange"),
  },
  yearly: {
    id: "yearly",
    getLastChangeName: () => i18n.t("pages.products.overview.lastYearChange"),
  },
});

export const ALL_FREQUENCIES = Object.freeze([
  UpdateFrequency.daily,
  UpdateFrequency.weekly,
  UpdateFrequency.weeklyAndEndOfMonth,
  UpdateFrequency.monthly,
  UpdateFrequency.quarterly,
  UpdateFrequency.yearly,
]);

export const DAILY_FREQUENCIES = Object.freeze([UpdateFrequency.daily]);

export const WEEKLY_AND_BELOW_FREQUENCIES = Object.freeze([
  UpdateFrequency.daily,
  UpdateFrequency.weekly,
  UpdateFrequency.weeklyAndEndOfMonth,
]);

export const MONTHLY_AND_BELOW_FREQUENCIES = Object.freeze([
  UpdateFrequency.daily,
  UpdateFrequency.weekly,
  UpdateFrequency.weeklyAndEndOfMonth,
  UpdateFrequency.monthly,
]);
